import { useState } from "react";
import { useParams } from "react-router-dom";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import { useDeleteSubdivisionChildAccountNoteByIdMutation, useGetSubdivisionChildAccountNotesServiceQuery } from "../subDivisionApi";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";

const ChildAccountNotes = () => {

    const { subdivisionId } = useParams();
    const [certificateNoteId, setCertificateNoteId] = useState(null);
    const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteNotesApi, { isLoading }] = useDeleteSubdivisionChildAccountNoteByIdMutation();
    const [showNoteUpdateModel, setShowNoteUpdateModel] = useState(false);

    const [noteObject, setNoteObject] = useState(null);

    const {
        data: certificateNotes,
    } = useGetSubdivisionChildAccountNotesServiceQuery(subdivisionId || "");

    const handleDeleteCertificateNotes = async (e: any) => {
        e.preventDefault();
        if (certificateNoteId !== null && certificateNoteId !== '') {
            try {
                await deleteNotesApi(certificateNoteId);
                setShowDeleteConfirm(false);
            } catch (error) {
                console.error('Error deleting certificate note:', error);
            }
        }
    };

    return (

        <div className={"mt-3"}>

            <CommonCertificateNotesForm
                title={"Subdivision Child Account Notes"}
                data={certificateNotes}
                relationalId={subdivisionId}
                count={certificateNotes?.length || 0}
                setShowAddNoteModal={setShowManagementCertificateModal}
                setNoteObject={setNoteObject}
                setShowNoteUpdateModel={setShowNoteUpdateModel}
                setNoteId={setCertificateNoteId}
                setShowDeleteConfirm={setShowDeleteConfirm}
                createPermission={"SUBD-C"}
                updatePermission={"SUBD-U"}
                deletePermission={"SUBD-D"}
                type={"subdivision"}
            />
            {showManagementCertificateModal &&
                <CertNoteAddOrUpdateModal title={"Add Subdivision Child Account Note"}
                    show={showManagementCertificateModal}
                    setShow={setShowManagementCertificateModal}
                    relationalId={subdivisionId}
                    type={"Subd"}
                    length={certificateNotes && certificateNotes.length + 1}
                    btnName="Add"
                    actionType={"SubdivisionChild"}
                />}
            {showNoteUpdateModel &&
                <CertNoteAddOrUpdateModal title={"Update Subdivision Child Account Note"}
                    show={showNoteUpdateModel}
                    setShow={setShowNoteUpdateModel}
                    noteObj={noteObject}
                    relationalId={subdivisionId}
                    btnName={"Update"} type={"Subd"}
                    actionType={"SubdivisionChild"}
                />
            }

            {showDeleteConfirm && <ConfirmationModal title={"Delete Subdivision Child Account Note"}
                bodyMessage={"Are you sure you want to delete this child account note?"}
                onSubmit={handleDeleteCertificateNotes}
                show={showDeleteConfirm}
                setShow={setShowDeleteConfirm}
                isLoading={isLoading}
            />}
        </div>
    );
};

export default ChildAccountNotes;